import { Box } from '~/commonComponents';
import { EmptyScreen } from '~/commonComponents/EmptyScreen/EmptyScreen';

import EmptyReferralIcon from '~/images/referral/referral-empty.svg';

export const EmptyReferral = () => {
  return (
    <Box>
      <EmptyScreen
        Icon={() => <img src={EmptyReferralIcon} alt="icon" style={{ width: 172, height: 171 }} />}
        title={'No referrals yet!'}
        description="Invite your friends using the link above! Once your invites are on the way, you'll be able to follow their progress and track their status here."
      />
    </Box>
  );
};
